
    import { Component, Mixins, Prop } from 'vue-property-decorator';
    import {
        YRow, YCol, YSlide,
    } from '@components/index';
    // TODO: Remove import rogue slideshow for register error in console
    import ListWrapper from '@rogues/ListWrapper/shared/listWrapper';

    @Component({
        components: {
            YRow,
            YCol,
            YSlide,
        },
    })
    /**
     * @name Grid
     */
    export default class Grid extends Mixins(ListWrapper) {
        /**
         * Default size of the column
         */
        @Prop({ default: 4 }) size!: string | number;

        /**
         * Number of Col
         * 
         * @example
         * col: {
         *     xs: 12,
         *     sm: 6,
         *     md: 4,
         *     lg: 3,
         * }
         */
        @Prop({
            default: () => ({
                xs: 10,
                sm: 6,
                md: 4,
                lg: 3,
            }),
        }) col!: object;

        /**
         * Get Value of the Col Prop
         */
        localColSize: {[k: string]: string | number} = this.getValue('col');

        /**
         * Show column style on mobile size
         */
        @Prop({ type: Boolean }) noScroll!: boolean;

        /**
         * Slideshow config
         */
        mainSlideshow = {
            slug : 'slideshow',
            type : 'simple',
            props: {
                classes     : 'mb-8',
                effect      : 'slide',
                loop        : false,
                height      : 'auto',
                otherOptions: {
                    breakpoints: {
                        1200: {
                            slidesPerView: 4,
                            spaceBetween : 24,
                        },
                        992: {
                            slidesPerView: 2.3,
                            spaceBetween : 24,
                        },
                        0: {
                            slidesPerView: 1.5,
                            spaceBetween : 24,
                        },
                    },
                },
            },
        }
    }
